// Tags that disqualify a product from being shown in recommendation surfaces
// (cart FBT, buy-again, etc.)
const EXCLUDED_RECOMMENDATION_TAGS = ["bonus-gift", "algolia-ignore"]

// Shared rule for products surfaced as recommendations
const isRecommendableProduct = (product: any) => {
  return !!product?.availableForSale && !product?.tags?.some((tag: string) => EXCLUDED_RECOMMENDATION_TAGS.includes(tag))
}
export { EXCLUDED_RECOMMENDATION_TAGS, isRecommendableProduct }
